module.exports = __webpack_public_path__ + "static/media/sc.bc5125a2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sc.svg
// module id = 2203
// module chunks = 0